import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';
import { ProspectService } from 'services/prospect.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ProspectTourPaymentInfo } from 'app/models/prospect-tour-payment-info';
import { ProspectTourPayment } from 'app/models/prospect-tour-payment';
import { LabelValue } from 'app/models/labelvalue';  
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';

declare var Stripe: any;

@Component({
  selector: 'app-submit-payment',
  templateUrl: './submit-payment.component.html',
  styleUrls: ['./submit-payment.component.css']
})
export class SubmitPaymentComponent implements OnInit, OnDestroy {
  public static _API_ENDPOINT = environment.apiEndPoint;
  @ViewChild('cardInfo') cardInfo: ElementRef;
  
  cardFields: any[] = [];
  cardHandler = this.onChange.bind(this);
  errorMessage: String = null;
  tourCost: String = null;
  model: ProspectTourPaymentInfo = new ProspectTourPaymentInfo();
  stripe: any;
  elements: any;
  yardiKey: string = null;
  billingZipCode: String = null;
  paymentInProcess: boolean = false;
  hidden: boolean = true;
  city: String = null;
  address: String = null;
  customerName: String = null;
  country: LabelValue[] = [];
  billingCountry: String = 'US';

  constructor(private eventEmitterService: EventEmitterService, private prospectService: ProspectService, public router: Router, private cd: ChangeDetectorRef, private errorService: ErrorService, private splashService: SplashService) {
    this.eventEmitterService.selfTourStepChange(3);

    let yardiKey = localStorage.getItem('YardiID');

    if (yardiKey !== null && yardiKey !== undefined)
    {
      this.yardiKey = yardiKey;
    }

    this.prospectService.getSelfTourCost().subscribe(res => this.onGetTourCost(res), res => this.errorService.showError(res));

    this.prospectService.GetSelfTourPaymentInfo(this.yardiKey).subscribe(res => this.onGetSelfTourPaymentInfo(res), res => this.errorService.showError(res));
   }

  ngOnInit() {
    this.getCountries();
    this.splashService.updateSplash("selftour");
  }

  ngOnDestroy() {
    if (this.model.HasActivePayment == false)
    {
      this.cardFields.forEach(card => {
        card.removeEventListener('change', this.cardHandler);
        card.destroy();
      });
      
    }
  }

  initializeStripe() {
    if (this.model.HasActivePayment === false)
    {
      this.stripe = new Stripe(this.model.StripePublishableKey);
      this.elements = this.stripe.elements();

      // Create an instance of the card Element.
      var cardField1 = this.elements.create('cardNumber');
      cardField1.mount('#ccNumberAnchor');
      cardField1.addEventListener('change', this.cardHandler);
      this.cardFields.push(cardField1);

      var cardField2 = this.elements.create('cardExpiry');
      cardField2.mount('#ccExpireAnchor');
      cardField2.addEventListener('change', this.cardHandler);
      this.cardFields.push(cardField2);

      var cardField3 = this.elements.create('cardCvc');
      cardField3.mount('#ccCVCAnchor');
      cardField3.addEventListener('change', this.cardHandler);
      this.cardFields.push(cardField3);
    }
    else {
      this.router.navigate(['/tour/selftour/schedule-selftour']);
    }
  }
  
  getCountries() {
    this.country.push({value:"US", label:'United States'})
    this.country.push({value:"AF", label:'Afghanistan'})
    this.country.push({value:"AX", label:'Åland Islands'})
    this.country.push({value:"AL", label:'Albania'})
    this.country.push({value:"DZ", label:'Algeria'})
    this.country.push({value:"AS", label:'American Samoa'})
    this.country.push({value:"AD", label:'Andorra'})
    this.country.push({value:"AO", label:'Angola'})
    this.country.push({value:"AI", label:'Anguilla'})
    this.country.push({value:"AQ", label:'Antarctica'})
    this.country.push({value:"AG", label:'Antigua and Barbuda'})
    this.country.push({value:"AR", label:'Argentina'})
    this.country.push({value:"AM", label:'Armenia'})
    this.country.push({value:"AW", label:'Aruba'})
    this.country.push({value:"AU", label:'Australia'})
    this.country.push({value:"AT", label:'Austria'})
    this.country.push({value:"AZ", label:'Azerbaijan'})
    this.country.push({value:"BS", label:'Bahamas'})
    this.country.push({value:"BH", label:'Bahrain'})
    this.country.push({value:"BD", label:'Bangladesh'})
    this.country.push({value:"BB", label:'Barbados'})
    this.country.push({value:"BY", label:'Belarus'})
    this.country.push({value:"BE", label:'Belgium'})
    this.country.push({value:"BZ", label:'Belize'})
    this.country.push({value:"BJ", label:'Benin'})
    this.country.push({value:"BM", label:'Bermuda'})
    this.country.push({value:"BT", label:'Bhutan'})
    this.country.push({value:"BO", label:'Bolivia, Plurinational State of'})
    this.country.push({value:"BQ", label:'Bonaire, Sint Eustatius and Saba'})
    this.country.push({value:"BA", label:'Bosnia and Herzegovina'})
    this.country.push({value:"BW", label:'Botswana'})
    this.country.push({value:"BV", label:'Bouvet Island'})
    this.country.push({value:"BR", label:'Brazil'})
    this.country.push({value:"IO", label:'British Indian Ocean Territory'})
    this.country.push({value:"BN", label:'Brunei Darussalam'})
    this.country.push({value:"BG", label:'Bulgaria'})
    this.country.push({value:"BF", label:'Burkina Faso'})
    this.country.push({value:"BI", label:'Burundi'})
    this.country.push({value:"KH", label:'Cambodia'})
    this.country.push({value:"CM", label:'Cameroon'})
    this.country.push({value:"CA", label:'Canada'})
    this.country.push({value:"CV", label:'Cape Verde'})
    this.country.push({value:"KY", label:'Cayman Islands'})
    this.country.push({value:"CF", label:'Central African Republic'})
    this.country.push({value:"TD", label:'Chad'})
    this.country.push({value:"CL", label:'Chile'})
    this.country.push({value:"CN", label:'China'})
    this.country.push({value:"CX", label:'Christmas Island'})
    this.country.push({value:"CC", label:'Cocos Keeling Islands'})
    this.country.push({value:"CO", label:'Colombia'})
    this.country.push({value:"KM", label:'Comoros'})
    this.country.push({value:"CG", label:'Congo'})
    this.country.push({value:"CD", label:'Congo, the Democratic Republic of the'})
    this.country.push({value:"CK", label:'Cook Islands'})
    this.country.push({value:"CR", label:'Costa Rica'})
    this.country.push({value:"CI", label:'Côte d\'Ivoire'})
    this.country.push({value:"HR", label:'Croatia'})
    this.country.push({value:"CU", label:'Cuba'})
    this.country.push({value:"CW", label:'Curaçao'})
    this.country.push({value:"CY", label:'Cyprus'})
    this.country.push({value:"CZ", label:'Czech Republic'})
    this.country.push({value:"DK", label:'Denmark'})
    this.country.push({value:"DJ", label:'Djibouti'})
    this.country.push({value:"DM", label:'Dominica'})
    this.country.push({value:"DO", label:'Dominican Republic'})
    this.country.push({value:"EC", label:'Ecuador'})
    this.country.push({value:"EG", label:'Egypt'})
    this.country.push({value:"SV", label:'El Salvador'})
    this.country.push({value:"GQ", label:'Equatorial Guinea'})
    this.country.push({value:"ER", label:'Eritrea'})
    this.country.push({value:"EE", label:'Estonia'})
    this.country.push({value:"ET", label:'Ethiopia'})
    this.country.push({value:"FK", label:'Falkland Islands Malvinas'})
    this.country.push({value:"FO", label:'Faroe Islands'})
    this.country.push({value:"FJ", label:'Fiji'})
    this.country.push({value:"FI", label:'Finland'})
    this.country.push({value:"FR", label:'France'})
    this.country.push({value:"GF", label:'French Guiana'})
    this.country.push({value:"PF", label:'French Polynesia'})
    this.country.push({value:"TF", label:'French Southern Territories'})
    this.country.push({value:"GA", label:'Gabon'})
    this.country.push({value:"GM", label:'Gambia'})
    this.country.push({value:"GE", label:'Georgia'})
    this.country.push({value:"DE", label:'Germany'})
    this.country.push({value:"GH", label:'Ghana'})
    this.country.push({value:"GI", label:'Gibraltar'})
    this.country.push({value:"GR", label:'Greece'})
    this.country.push({value:"GL", label:'Greenland'})
    this.country.push({value:"GD", label:'Grenada'})
    this.country.push({value:"GP", label:'Guadeloupe'})
    this.country.push({value:"GU", label:'Guam'})
    this.country.push({value:"GT", label:'Guatemala'})
    this.country.push({value:"GG", label:'Guernsey'})
    this.country.push({value:"GN", label:'Guinea'})
    this.country.push({value:"GW", label:'Guinea-Bissau'})
    this.country.push({value:"GY", label:'Guyana'})
    this.country.push({value:"HT", label:'Haiti'})
    this.country.push({value:"HM", label:'Heard Island and McDonald Islands'})
    this.country.push({value:"VA", label:'Holy See Vatican City State'})
    this.country.push({value:"HN", label:'Honduras'})
    this.country.push({value:"HK", label:'Hong Kong'})
    this.country.push({value:"HU", label:'Hungary'})
    this.country.push({value:"IS", label:'Iceland'})
    this.country.push({value:"IN", label:'India'})
    this.country.push({value:"ID", label:'Indonesia'})
    this.country.push({value:"IR", label:'Iran, Islamic Republic of'})
    this.country.push({value:"IQ", label:'Iraq'})
    this.country.push({value:"IE", label:'Ireland'})
    this.country.push({value:"IM", label:'Isle of Man'})
    this.country.push({value:"IL", label:'Israel'})
    this.country.push({value:"IT", label:'Italy'})
    this.country.push({value:"JM", label:'Jamaica'})
    this.country.push({value:"JP", label:'Japan'})
    this.country.push({value:"JE", label:'Jersey'})
    this.country.push({value:"JO", label:'Jordan'})
    this.country.push({value:"KZ", label:'Kazakhstan'})
    this.country.push({value:"KE", label:'Kenya'})
    this.country.push({value:"KI", label:'Kiribati'})
    this.country.push({value:"KP", label:'Korea, Democratic People\'s Republic of'})
    this.country.push({value:"KR", label:'Korea, Republic of'})
    this.country.push({value:"KW", label:'Kuwait'})
    this.country.push({value:"KG", label:'Kyrgyzstan'})
    this.country.push({value:"lA", label:'Lao People\'s Democratic Republic'})
    this.country.push({value:"lV", label:'Latvia'})
    this.country.push({value:"lB", label:'Lebanon'})
    this.country.push({value:"LS", label:'Lesotho'})
    this.country.push({value:"LR", label:'Liberia'})
    this.country.push({value:"LY", label:'Libya'})
    this.country.push({value:"LI", label:'Liechtenstein'})
    this.country.push({value:"LT", label:'Lithuania'})
    this.country.push({value:"LU", label:'Luxembourg'})
    this.country.push({value:"MO", label:'Macao'})
    this.country.push({value:"MK", label:'Macedonia, the former Yugoslav Republic of'})
    this.country.push({value:"MG", label:'Madagascar'})
    this.country.push({value:"MW", label:'Malawi'})
    this.country.push({value:"MY", label:'Malaysia'})
    this.country.push({value:"MV", label:'Maldives'})
    this.country.push({value:"ML", label:'Mali'})
    this.country.push({value:"MT", label:'Malta'})
    this.country.push({value:"MH", label:'Marshall Islands'})
    this.country.push({value:"MQ", label:'Martinique'})
    this.country.push({value:"MR", label:'Mauritania'})
    this.country.push({value:"MU", label:'Mauritius'})
    this.country.push({value:"YT", label:'Mayotte'})
    this.country.push({value:"MX", label:'Mexico'})
    this.country.push({value:"FM", label:'Micronesia, Federated States of'})
    this.country.push({value:"MD", label:'Moldova, Republic of'})
    this.country.push({value:"MC", label:'Monaco'})
    this.country.push({value:"MN", label:'Mongolia'})
    this.country.push({value:"ME", label:'Montenegro'})
    this.country.push({value:"MS", label:'Montserrat'})
    this.country.push({value:"MA", label:'Morocco'})
    this.country.push({value:"MZ", label:'Mozambique'})
    this.country.push({value:"MM", label:'Myanmar'})
    this.country.push({value:"NA", label:'Namibia'})
    this.country.push({value:"NR", label:'Nauru'})
    this.country.push({value:"NP", label:'Nepal'})
    this.country.push({value:"NL", label:'Netherlands'})
    this.country.push({value:"NC", label:'New Caledonia'})
    this.country.push({value:"NZ", label:'New Zealand'})
    this.country.push({value:"NI", label:'Nicaragua'})
    this.country.push({value:"NE", label:'Niger'})
    this.country.push({value:"NG", label:'Nigeria'})
    this.country.push({value:"NU", label:'Niue'})
    this.country.push({value:"NF", label:'Norfolk Island'})
    this.country.push({value:"MP", label:'Northern Mariana Islands'})
    this.country.push({value:"NO", label:'Norway'})
    this.country.push({value:"OM", label:'Oman'})
    this.country.push({value:"PK", label:'Pakistan'})
    this.country.push({value:"PW", label:'Palau'})
    this.country.push({value:"PS", label:'Palestinian Territory, Occupied'})
    this.country.push({value:"PA", label:'Panama'})
    this.country.push({value:"PG", label:'Papua New Guinea'})
    this.country.push({value:"PY", label:'Paraguay'})
    this.country.push({value:"PE", label:'Peru'})
    this.country.push({value:"PH", label:'Philippines'})
    this.country.push({value:"PN", label:'Pitcairn'})
    this.country.push({value:"PL", label:'Poland'})
    this.country.push({value:"PT", label:'Portugal'})
    this.country.push({value:"PR", label:'Puerto Rico'})
    this.country.push({value:"QA", label:'Qatar'})
    this.country.push({value:"RE", label:'Réunion'})
    this.country.push({value:"RO", label:'Romania'})
    this.country.push({value:"RU", label:'Russian Federation'})
    this.country.push({value:"RW", label:'Rwanda'})
    this.country.push({value:"BL", label:'Saint Barthélemy'})
    this.country.push({value:"SH", label:'Saint Helena, Ascension and Tristan da Cunha'})
    this.country.push({value:"KN", label:'Saint Kitts and Nevis'})
    this.country.push({value:"lC", label:'Saint Lucia'})
    this.country.push({value:"MF", label:'Saint Martin ({French part'})
    this.country.push({value:"PM", label:'Saint Pierre and Miquelon'})
    this.country.push({value:"VC", label:'Saint Vincent and the Grenadines'})
    this.country.push({value:"WS", label:'Samoa'})
    this.country.push({value:"SM", label:'San Marino'})
    this.country.push({value:"ST", label:'Sao Tome and Principe'})
    this.country.push({value:"SA", label:'Saudi Arabia'})
    this.country.push({value:"SN", label:'Senegal'})
    this.country.push({value:"RS", label:'Serbia'})
    this.country.push({value:"SC", label:'Seychelles'})
    this.country.push({value:"SL", label:'Sierra Leone'})
    this.country.push({value:"SG", label:'Singapore'})
    this.country.push({value:"SX", label:'Sint Maarten ({Dutch part'})
    this.country.push({value:"SK", label:'Slovakia'})
    this.country.push({value:"SI", label:'Slovenia'})
    this.country.push({value:"SB", label:'Solomon Islands'})
    this.country.push({value:"SO", label:'Somalia'})
    this.country.push({value:"ZA", label:'South Africa'})
    this.country.push({value:"GS", label:'South Georgia and the South Sandwich Islands'})
    this.country.push({value:"SS", label:'South Sudan'})
    this.country.push({value:"ES", label:'Spain'})
    this.country.push({value:"lK", label:'Sri Lanka'})
    this.country.push({value:"SD", label:'Sudan'})
    this.country.push({value:"SR", label:'Suriname'})
    this.country.push({value:"SJ", label:'Svalbard and Jan Mayen'})
    this.country.push({value:"SZ", label:'Swaziland'})
    this.country.push({value:"SE", label:'Sweden'})
    this.country.push({value:"CH", label:'Switzerland'})
    this.country.push({value:"SY", label:'Syrian Arab Republic'})
    this.country.push({value:"TW", label:'Taiwan, Province of China'})
    this.country.push({value:"TJ", label:'Tajikistan'})
    this.country.push({value:"TZ", label:'Tanzania, United Republic of'})
    this.country.push({value:"TH", label:'Thailand'})
    this.country.push({value:"TL", label:'Timor-Leste'})
    this.country.push({value:"TG", label:'Togo'})
    this.country.push({value:"TK", label:'Tokelau'})
    this.country.push({value:"TO", label:'Tonga'})
    this.country.push({value:"TT", label:'Trinidad and Tobago'})
    this.country.push({value:"TN", label:'Tunisia'})
    this.country.push({value:"TR", label:'Turkey'})
    this.country.push({value:"TM", label:'Turkmenistan'})
    this.country.push({value:"TC", label:'Turks and Caicos Islands'})
    this.country.push({value:"TV", label:'Tuvalu'})
    this.country.push({value:"UG", label:'Uganda'})
    this.country.push({value:"UA", label:'Ukraine'})
    this.country.push({value:"AE", label:'United Arab Emirates'})
    this.country.push({value:"GB", label:'United Kingdom'})
    this.country.push({value:"UM", label:'United States Minor Outlying Islands'})
    this.country.push({value:"UY", label:'Uruguay'})
    this.country.push({value:"UZ", label:'Uzbekistan'})
    this.country.push({value:"VU", label:'Vanuatu'})
    this.country.push({value:"VE", label:'Venezuela, Bolivarian Republic of'})
    this.country.push({value:"VN", label:'Viet Nam'})
    this.country.push({value:"VG", label:'Virgin Islands, British'})
    this.country.push({value:"VI", label:'Virgin Islands, U.S.'})
    this.country.push({value:"WF", label:'Wallis and Futuna'})
    this.country.push({value:"EH", label:'Western Sahara'})
    this.country.push({value:"YE", label:'Yemen'})
    this.country.push({value:"ZM", label:'Zambia'})
    this.country.push({value:"ZW", label:'Zimbabwe'})
  }

  onGetTourCost(cost: string)
  {
    this.tourCost = cost;
  }

  onChange({ error }) {
    if (error) {
      this.errorMessage = error.message;
    } else {
      this.errorMessage = null;
    }
    this.cd.detectChanges();
  }

  onGetSelfTourPaymentInfo(info: ProspectTourPaymentInfo)
  {
    this.model = info;

    if (this.model.HasActivePayment)
    {
      this.router.navigate(['/tour/selftour/schedule-selftour']);
    }
    else {
      this.hidden = false;
      this.initializeStripe();
    }
  }

async submitPayment(element: { textContent: any; disabled: any; })
{
  if (this.paymentInProcess === false)
  {
    if (this.billingZipCode === null)
    {
      this.errorMessage = "Please complete the billing zip code";
    }
    else if (this.customerName === null)
    {
      this.errorMessage = "Please complete the name field";
    }
    else if (this.address === null)
    {
      this.errorMessage = "Please complete the address field";
    }
    else if (this.city === null)
    {
      this.errorMessage = "Please complete the city field";
    }
    else if (this.country === null)
    {
      this.errorMessage = "Please complete the country field";
    }
    else {
      element.textContent = 'PROCESSING';
      element.disabled = true;
      this.paymentInProcess = true;

      let data = {
        address_line1: this.address,
        name: this.customerName,
        address_zip: this.billingZipCode,
        address_country: this.billingCountry,
        address_city: this.city,
      };
       const { token, error } = await this.stripe.createToken(this.cardFields[0], data);
  
      if (error) {
        this.paymentInProcess = false;
        this.errorMessage = error.message;
        element.textContent = 'SUBMIT PAYMENT';
        element.disabled = false;      
      } else {
        let payload = new ProspectTourPayment(null, 'usd', token.id, null, this.yardiKey);
        this.prospectService.ProcessPayment(payload).subscribe(res => this.onProcessPayment(res, element), res => this.onProcessPaymentError(res, element));
      }
    }
  }
}

onProcessPaymentError(data: any, element: { textContent: string; disabled: boolean; })
{
  if (data.Status == "Error" && data.StripeErrorMsg === "summary-r")
  {
    localStorage.setItem("SummaryError", "Sorry we were not able to process your request at this time.");
    this.router.navigate(['/tour/selftour/schedule-selftour']);
  }
  else {
    let response = JSON.parse(data._body);
    // Card was not processed
      // Display Error and let customer try again.
      this.errorMessage = response.Message;
      this.paymentInProcess = false;
      element.textContent = 'SUBMIT PAYMENT';
      element.disabled = false; 
  }
}

onProcessPayment(data: any, element: { textContent: string; disabled: boolean; })
{ 
  if (data.Status === 'succeeded') {
    // Card charged, create door code and go to next step
    this.router.navigate(['/tour/selftour/schedule-selftour']);
  } else {
    this.onProcessPaymentError(data, element);
  }
}

back()
  {
    this.router.navigate(['/tour/selftour/confirm-info']);
  }

}
